'use strict';

export default function removeGetParameter(removed_field = '') {
  let searched = (document.location.search || '').replace('?', '&').split('=').filter(str => str);
  let splited = [];
  searched.forEach(function (str, i) {
    if (str.includes('&') && str.startsWith('&') === false) {
      const trunc = str.split('&');
      splited.push(trunc[0]);
      splited.push('&' + trunc[1]);
    } else {
      splited.push(str);
    }
  });
  let data = {};
  splited.forEach(function (str, i) {
    if (str.startsWith('&')) {
      data[str.slice(1)] = '';
    } else {
      const prev_str = splited[i - 1];
      if (prev_str && prev_str.slice(1)) {
        data[prev_str.slice(1)] = str;
      }
    }
  });
  let new_pathname = document.location.pathname;
  Object.keys(data).filter(field => field !== removed_field).forEach(function (field, i) {
    new_pathname += i === 0 ? '?' : '&';
    new_pathname += field + '=' + data[field];
  });
  window.history.replaceState({}, document.title, new_pathname);
}
